import {
  SET_PICKUP_ADDRESS,
  GET_GEOSUGGEST_ADDRESS,
  FETCH_GEOSUGGEST_ADDRESS_SUCCESS,
  FETCH_GEOSUGGEST_ADDRESS_ERROR,
  HANDLE_PICKUPADDRESS_FORM_CHANGE,
  SET_SUGGESTADDRESS,
  ON_AUTOFILL_SELECT,
  PICKUPADDRESS_FORM_SUBMISSION,
  UPDATE_PICKUPADDRESS,
  SET_ADDRESS_ERRORS,
  COPY_GEOSUGGEST_ADDRESS,
  checkAddressEditFlag
} from "../actions/address";
import { handlePickupFormChange } from "../actions/pickupForm";

import { apiRequest } from "../actions/api";
import { GOOGLE_SUGGEST_ADDRESS_URL } from "../../config";

export const autoFillAddress = ({ dispatch, getState }) => next => action => {
  next(action);
  if (action.type === ON_AUTOFILL_SELECT) {
    let newState = {};
    let streetNumber;
    let route, p1Andp2;
    if (action.payload) {
      if (action.payload.gmaps) {
        action.payload.gmaps.address_components.map(i => {
          const { long_name, types, short_name } = i;
          if (isPresentInArray(types, "establishment")) {
            newState.establishment = long_name.toUpperCase();
          } else if (isPresentInArray(types, "street_number")) {
            streetNumber = long_name.toUpperCase();
          } else if (isPresentInArray(types, "route")) {
            route = long_name.toUpperCase();
          } else if (isPresentInArray(types, "postal_code")) {
            p1Andp2 = long_name.toUpperCase()
            newState.zip = p1Andp2;
          } else if (isPresentInArray(types, "country")) {
            newState.state = short_name.toUpperCase();
          } else if (isPresentInArray(types, "postal_town")) {
            newState.city = long_name.toUpperCase();
          }
        });
        const formattedAddress = action.payload.gmaps.formatted_address.split(
          ","
        );
        newState.addressLine1 = '';
        if (streetNumber || route) {
          if (streetNumber) {
            newState.addressLine1 = streetNumber;
          }
          if (route) {
            newState.addressLine1 = newState.addressLine1 + " " + route;
          }
        } else {
          newState.addressLine1 = formattedAddress[0];
        }

        //TODO: perhaps, handle it in a single function.
        dispatch(handlePickupFormChange("addressLine1", newState.addressLine1));
        dispatch(
          handlePickupFormChange(
            "city",
            newState.city !== undefined ? newState.city : ""
          )
        );
        dispatch(
          handlePickupFormChange(
            "state",
            newState.state !== undefined ? newState.state : ""
          )
        );
        dispatch(
          handlePickupFormChange(
            "zip",
            newState.zip !== undefined ? newState.zip : ""
          )
        );

        //dispatch({ type: SET_PICKUP_ADDRESS, payload: newState });
      }
    }
  }
};

export const copySuggestAddress = ({
  dispatch,
  getState
}) => next => action => {
  next(action);
  if (action.type === COPY_GEOSUGGEST_ADDRESS) {
    const {
      addressLine1,
      addressLine2,
      city,
      state,
      zip
    } = getState().address.geoSuggestAddress;
    dispatch(handlePickupFormChange("addressLine1", addressLine1));
    dispatch(handlePickupFormChange("city", city));
    dispatch(handlePickupFormChange("state", state));
    dispatch(handlePickupFormChange("zip", zip));
  }
};

export const getGeoSuggestAddress = ({
  dispatch,
  getState
}) => next => action => {
  next(action);
  if (action.type === GET_GEOSUGGEST_ADDRESS) {
    const {
      addressLine1,
      addressLine2,
      city,
      state,
      zip
    } = getState().address.pickupAddress;

    const query = `${addressLine1} ${addressLine2} ${city} ${state} ${zip}`;

    const getSuggestUrlWithQuery = GOOGLE_SUGGEST_ADDRESS_URL(query);
    dispatch(
      apiRequest(
        "GET",
        getSuggestUrlWithQuery,
        null,
        FETCH_GEOSUGGEST_ADDRESS_SUCCESS,
        FETCH_GEOSUGGEST_ADDRESS_ERROR
      )
    );
  }
};

export const handleAddressFieldsChange = ({
  dispatch,
  getState
}) => next => action => {
  next(action);
  if (action.type === HANDLE_PICKUPADDRESS_FORM_CHANGE) {
    let field = Object.keys(action.payload)[0];
    dispatch({ type: UPDATE_PICKUPADDRESS, payload: action.payload });
    dispatch({ type: SET_ADDRESS_ERRORS, payload: { [field]: "" } });
  }
};

export const addressSubmission = ({ dispatch, getState }) => next => action => {
  next(action);
  if (action.type === PICKUPADDRESS_FORM_SUBMISSION) {
  }
};

export const fetchGeoSuggestSuccess = ({ dispatch }) => next => action => {
  next(action);
  if (action.type === FETCH_GEOSUGGEST_ADDRESS_SUCCESS) {
    // const  {line1, line2, city, county, p1, p2}= action.payload.address;
    let streetNumber;
    let route;
    let p1Andp2, state, city;
    action.payload.results[0].address_components.map(i => {
      const { long_name, types, short_name } = i;
      if (isPresentInArray(types, "street_number")) {
        streetNumber = long_name.toUpperCase();
      } else if (isPresentInArray(types, "route")) {
        route = long_name.toUpperCase();
      } else if (isPresentInArray(types, "postal_code")) {
        p1Andp2 = long_name.toUpperCase();
      } else if (isPresentInArray(types, "country")) {
        state = short_name.toUpperCase();
      } else if (isPresentInArray(types, "postal_town")) {
        city = long_name.toUpperCase();
      }
    });

    let line1 = "";
    if (streetNumber || route) {
      if (streetNumber) {
        line1 = streetNumber;
      }
      if (route) {
        line1 = line1 + " " + route;
      }
    }
    let suggestAddress = {
      addressLine1: line1,
      // addressLine2,
      city: city,
      state: state,
      zip: p1Andp2,
      isPartialMatch: action.payload.results[0].partial_match ? action.payload.results[0].partial_match : false
    };
    dispatch({ type: SET_SUGGESTADDRESS, payload: suggestAddress });
    if (suggestAddress.isPartialMatch === true) {
      dispatch(checkAddressEditFlag());
    }
  }
};

export const addressMdl = [
  autoFillAddress,
  getGeoSuggestAddress,
  handleAddressFieldsChange,
  addressSubmission,
  fetchGeoSuggestSuccess,
  copySuggestAddress
];

const isPresentInArray = (array, property) => array.indexOf(property) !== -1;


// WEBPACK FOOTER //
// ./src/redux/middleware/address.uk.js